export default {
  text: '#202020',
  primary: '#8e2220',
  secondary: '#beac74',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#484848'
}
